"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.purposeOfVisitComingToCanadaList = exports.purposeOfVisitList = void 0;
exports.purposeOfVisitList = [
    {
        value: "01",
        label: "Business",
    },
    {
        value: "02",
        label: "Tourism",
    },
    {
        value: "04",
        label: "Short-Term Studies",
    },
    {
        value: "05",
        label: "Returning Student",
    },
    {
        value: "06",
        label: "Returning Worker",
    },
    {
        value: "07",
        label: "Super Visa: For Parents or Grandparents",
    },
    {
        value: "08",
        label: "Family Visit",
    },
    {
        value: "13",
        label: "Visit",
    },
    {
        value: "03",
        label: "Other",
    },
];
// This is for the Inside Canada Applications (5708. 5709, 5710)
exports.purposeOfVisitComingToCanadaList = [
    {
        value: "01",
        label: "Business",
    },
    {
        value: "02",
        label: "Tourism",
    },
    {
        value: "04",
        label: "Study",
    },
    {
        value: "05",
        label: "Work",
    },
    {
        value: "03",
        label: "Other",
    },
    {
        value: "06",
        label: "Family Visit",
    },
];
